import { Component, Input, AfterViewInit, ViewChild } from '@angular/core';
import { SignOutDialog } from '../dialogs/sign-out.dialog';
import { MatDialog } from '@angular/material/dialog';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { MatAccordion } from '@angular/material/expansion';
import { DataHelper } from '@helpers/data.helper';
import { environment } from '@environments/environment';
import { PromotionService } from '@services/promotion.service';
import { getProductName } from '@pipes/getProductName.pipe';

@Component({
  selector: 'right-menu',
  templateUrl: '../sharedTemplates/right-menu.component.html',
})
export class RightMenuComponent implements AfterViewInit {
  quickTippChecked = false;

  selectMenu: number;
  userDropdownIsOpen = false;
  isOpenLangMenu = false;
  isOpenOddFormatMenu = false;
  langDatas;
  langDatasArry = [];
  selectedLang = '';
  currentRoute = '';

  @Input() isPlained = false;
  @Input() isCasino = false;

  @ViewChild('accordion', { static: true }) accordion: MatAccordion;

  constructor(
    public _MatDialog: MatDialog,
    public _UserHelper: UserHelper,
    public _UiHelper: UiHelper,
    private _router: Router,
    public _LocalizationService: LocalizationService,
    public dialog: MatDialog,
    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    public _PromotionService: PromotionService
  ) {
    this.quickTippChecked = this._UiHelper.getQuickTipp();

    this.currentRoute = this._UiHelper.currentRoute;
    this._UiHelper.currentRouteListener.subscribe(x => (this.currentRoute = x));
  }

  ngAfterViewInit() {
    window.scroll(0, 0);

    this.selectedLang = this._LocalizationService.LANGCODE;
    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
  }
  walletSelectChange(walletItem) {
    if (walletItem?.IsActive) {
      this._UiHelper.setLoadingDialog(true);

      this._ApiService.switchWallet(walletItem.CustomerId, walletItem.BranchId).then(result => {
        this._DataHelper.selectedWallet = walletItem;
        if (environment.isMySlipLive) {
          this._DataHelper.mySlipMatchListApiCallListener.emit();
        }
        this._ApiService
          .getClient()
          .then(result => {
            this._UiHelper.setLoadingDialog(false);
            this._UserHelper.setUser(result);
          })
          .catch();

        this._ApiService.getTaxRate().then(result => {
          this._DataHelper.setTaxRate(result);
        });
      });
    }
  }
  SignOutDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      this._UiHelper.closeAllMenus();
      dialogRef
        .open(SignOutDialog, {
          width: '350px',
        })
        .afterClosed()
        .subscribe(result => {
          //////console.log('The dialog was closed' + result);
        });
    } else {
      dialogRef.closeAll();
    }
    // dialogRef.componentInstance.data = purpose;
  }

  changeTheme() {
    this._UiHelper.darkThemeListener.emit();
  }

  closeSideBar() {
    this._UiHelper.SetRightMenuState('close');
  }

  userDropdownOpen() {
    this.userDropdownIsOpen = !this.userDropdownIsOpen;
  }

  OpenAccountMobile(selectMenu) {
    this.selectMenu = selectMenu;
    this._UiHelper.SetRightMenuState('close');
    this._router.navigate([selectMenu]);
  }

  changeQuickTipp() {
    this._UiHelper.changeQuickTipp();
  }

  selectFormatType(changes): void {
    this._UiHelper.selectedFormatType(changes);
  }

  toggleOddFormatMenu() {
    this.isOpenOddFormatMenu = !this.isOpenOddFormatMenu;
  }

  protected readonly environment = environment;
  protected readonly isNaN = isNaN;
}
